import SEOMetadata from "../../components/SEOMetadata";
import { seoConfig } from "../../config/seoConfig";
import Attachments from "../../components/home/attachments/attachments";
import Banner from "../../components/home/banner/Banner";
import BuildFleet from "../../components/home/buildFleet/buildFleet";
import BuildTuatara from "../../components/home/buildTuatara/buildTuatara";
import DealerLocator from "../../components/home/dealerLocator/dealerLocator";
import Journey from "../../components/home/journey/journey";
import ModelsInfo from "../../components/home/modelsInfo/modelsInfo";
import WarrantyCard from "../../components/home/warrantyCard/warrantyCard";
import usePageTitle from "../../hooks/usePageTitle";
import VideoSchema from "../../components/schema/VideoSchema";

const Home = () => {
  const seoData = seoConfig.us.home;

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <div className="bg-[#fff]">
        {/* H1 is rendered visibly inside <Banner />, so no separate sr-only H1 here (avoids duplicate H1s). */}
        <Banner />
        <ModelsInfo />
        <div className=" my-[50px]">
          <VideoSchema
            title="Tuatara UTV Showcase"
            description="Explore the Tuatara range of heavy duty off-road utility vehicles in action."
            thumbnailUrl="https://img.youtube.com/vi/4xLu2TscEew/maxresdefault.jpg"
            uploadDate="2023-01-01"
            duration="PT1M00S"
            contentUrl="https://www.youtube.com/embed/4xLu2TscEew"
            embedUrl="https://www.youtube.com/embed/4xLu2TscEew?si=hEWcAYaVCGfFS1bU"
          />
          <div className="custom-container text-center lg:mb-[40px] md:mb-[30px] mb-[20px]">
            <h2 className="font-[Rockwell] font-extrabold 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[18px] text-[#292929]  pb-[50px]">
              Power Through Any Terrain.
            </h2>
          </div>
          <div className="relative custom-container lg:h-[500px] md:h-[350px] h-[300px]">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/4xLu2TscEew?si=hEWcAYaVCGfFS1bU"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
          <div className="custom-container lg:mt-[40px] md:mt-[30px] mt-[20px]">
            <div className="text-center font-[Roboto] font-normal 2xl:text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] text-[14px] text-[#292929] lg:my-[20px] my-[14px]">
              From farms and job sites to rough off-road terrain, <strong>Tuatara UTVs are built to handle whatever you throw at them.</strong> These side-by-side utility vehicles are made to be versatile, taking on everything from heavy loads and daily work to weekend adventures with ease.
            </div>
            <div className="text-center font-[Roboto] font-normal 2xl:text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] text-[14px] text-[#292929]">
              With both gas and electric options available, it's easy to find a Tuatara that suits how you work. Whether you're out on the land, running a job site, or heading off the beaten track, you'll get a tough, reliable ride backed by durable all-steel construction and built to perform across all kinds of terrain.
            </div>
          </div>
          {/* <DealerLocator /> */}
        </div>
        <BuildTuatara />
        {/* <WarrantyCard /> */}
        <BuildFleet />
        {/* <Attachments /> */}

        <div className="bg-[#fff]">
          <div className="custom-container lg:pt-[90px] md:pt-[70px] sm:pt-[60px] pt-[50px] lg:pb-[90px] md:pb-[70px] sm:pb-[60px] pb-[50px]">
            <Journey title={"FIND A TUATARA FOR YOUR JOURNEY"} />
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
